<template>
  <v-layout align-center justify-center class="secondary darken-1">
    <v-img
      src="/img/recipe_placeholder.png"
      max-height="100%"
      max-width="100%"
    />
  </v-layout>
</template>

<script>
export default {
  name: "RecipeImagePlaceholder"
};
</script>
